import React, { useCallback } from "react";
import { Field, useForm } from "react-final-form";
import { makeStyles } from "@material-ui/core";
import BootstrapInput from "../../../../components/BootstrapInput";
import Autocomplete from "../../../../components/Autocomplete";
import { SCHOOL_GRADE } from "../../constants";

const useStyles = makeStyles(() => ({
  schoolGrade: {
    marginBottom: 16,
  },
}));

function SchoolGrade({ namePrefix }) {
  const classes = useStyles();
  const { change } = useForm();

  const handleAutocompleteChange = useCallback(() => {
    change(`${namePrefix}.otherGrade`, undefined);
  }, [namePrefix]);

  const handleBootstrapInputChange = useCallback(() => {
    change(`${namePrefix}.schoolGrade`, undefined);
  }, [namePrefix]);

  return (
    <>
      <div className={classes.schoolGrade}>
        <Field
          required
          fullWidth
          label="School Grade"
          options={SCHOOL_GRADE}
          placeholder="Please Select"
          changeCallback={handleAutocompleteChange}
          name={`${namePrefix}.schoolGrade`}
          component={Autocomplete}
        />
      </div>
      <div>
        <Field
          fullWidth
          type="text"
          label="Other Grade"
          placeholder="Other Grade"
          onChange={handleBootstrapInputChange}
          name={`${namePrefix}.otherGrade`}
          component={BootstrapInput}
        />
      </div>
    </>
  );
}

export default React.memo(SchoolGrade);
